function initializeSplideReassurance(splideElem) {
	if (splideElem.splideInstance) {
		splideElem.splideInstance.destroy(true);
	}
	var splideInstance = new Splide(splideElem, {
		type: "loop",
		arrows: false,
		pagination: false,
		perPage: 1,
		drag: "free",
		snap: true,
		fixedWidth: "100%",
		autoplay: true,
		interval: 4000,
		pauseOnHover: false,
		destroy: false,
		mediaQuery: "min",
		breakpoints: {
			769: {
				destroy: true,
			},
		},
	}).mount();
	splideElem.splideInstance = splideInstance;
	// Ajout de l'écouteur d'événement pour le défilement horizontal
	addHorizontalScrollListener(splideElem, splideInstance);
}

document.addEventListener("DOMContentLoaded", () => {
	initializeSectionsWithSplide("data-section-reassurance-id", ".mm-reassurance-splide", initializeSplideReassurance);
});
